import { render } from "./AlertComponent.vue?vue&type=template&id=5ecc33d2"
import script from "./AlertComponent.vue?vue&type=script&lang=js"
export * from "./AlertComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/kinetics/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__